import { render, staticRenderFns } from "./Affiliations.vue?vue&type=template&id=3454f092&scoped=true"
import script from "./Affiliations.vue?vue&type=script&lang=js"
export * from "./Affiliations.vue?vue&type=script&lang=js"
import style0 from "./Affiliations.vue?vue&type=style&index=0&id=3454f092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3454f092",
  null
  
)

export default component.exports